import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';

export const BarChartLegacy = ({ resultSet }) => {
  if (
    resultSet &&
    resultSet.loadResponse.query.measures &&
    resultSet.loadResponse.query.measures.length > 0
  ) {
    return (
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={resultSet.chartPivot()}>
          <XAxis dataKey="x" minTickGap={20} />
          <YAxis />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Legend />
          {resultSet.seriesNames().map(s => (
            <Bar key={s.key} dataKey={s.key} name={s.title} fill="#243377" />
          ))}
        </BarChart>
      </ResponsiveContainer>
    );
  }

  return 'Loading...';
};
